module.exports = __webpack_public_path__ + "static/img/0020.ce067b75.png";